export const env = {
  apiUrl: import.meta.env.VITE_API_URL ?? '',
  analyticsApiBase: import.meta.env.VITE_ANALYTICS_API_BASE ?? '/analytics-api',
  cmfApiKey: import.meta.env.VITE_CMF_API_KEY ?? '',
  baseUrl: import.meta.env.BASE_URL,
  mode: import.meta.env.MODE,
  isProduction: import.meta.env.MODE === 'production',
} as const
